import { UtilitarioService } from '@app/services/utilitario.service';
export class Baixa {

  public Tipo: string;
  public processoId: number;
  public documentoId: number;
  public valor: number;
  public trocoContaId: number;

  public valorRecebido: number;
  public valorRestante: number;
  public valorTroco: number;
  public formaDePagamentoCodigo: string;

  public formaDePagamento: BaixaFormaDePagamento[];
  public dataPagamento: string;
  // public dataPag: Date;

  constructor() {
    this.formaDePagamento = [];
    this.dataPagamento = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.valor = 0;
    this.valorRecebido = 0;
    this.valorTroco = 0;
    this.valorRestante = 0;
  }
}

export class BaixaFormaDePagamento {

  public formaDePagamentoId: number;
  public formaDePagamentoDescricao: string;
  public valorReal: number;
  public valorTroco: number;
  public valor: number;
  public contaId: number;
  public contaDescricao: string;

  public CadastrarCheque: boolean;
  public ChequeBancoId: number;
  public ChequeBancoDescricao: string;
  public ChequeAgencia: string;
  public ChequeConta: string;
  public ChequeProprio: boolean;
  public ChequeNumero: string;
  public ChequeTitular: string;
  public ChequeDataEmissao: string;
  public ChequeDataVencimento: string;

  constructor(formaDePagamentoId: number = 0, contaId: number = 0) {
    this.formaDePagamentoId = formaDePagamentoId;
    this.contaId = contaId;
    this.valor = 0;
    this.ChequeBancoId = 1;
  }
}

export class BaixaValorTemp {
  public Data: string;
  public Tipo: string;
  public DocumentoId: number;
  public Desconto: number;
  public Valor: number;
  public Historico: string;
  public BaixaParcial: boolean;
  public NovoDocumentoNumero: string;
  public NovoDocumentoDataVencimento: string;
}

export class BaixaInformacoes {
  public baixa: Baixa;
  public Troco: number;
  public Desconto: number;
  public Juros: number;
  public Numero: string;
  public Historico: string;
  public Credito: boolean; 
  public DataBaixa: string;
  public NovoVencimento: string;
}
